/* eslint-disable @typescript-eslint/no-explicit-any */
export function toggleFilterState<S extends Record<string, any>>(
  state: S,
  name: string
) {
  const filterSliceState = { ...state };

  const filterItem = filterSliceState.state[name];

  if (!filterItem) {
    return filterSliceState;
  }

  const isActive = !filterItem?.active;

  const updatedFilterSliceState = {
    ...filterSliceState,
    selectedFilters: {
      ...filterSliceState.selectedFilters,
      [name]: !isActive ? [] : filterSliceState.selectedFilters[name],
    },
    state: {
      ...filterSliceState.state,
      [name]: {
        ...filterItem,
        active: isActive,
      },
    },
  };

  return updatedFilterSliceState;
}
